import { render, staticRenderFns } from "./ResumeSchool.vue?vue&type=template&id=64fd1db4&scoped=true&"
import script from "./ResumeSchool.vue?vue&type=script&lang=js&"
export * from "./ResumeSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd1db4",
  null
  
)

export default component.exports